const AM_ENDPOINT =  "https://api.music.apple.com"; // "/api"; //       via proxy server for prod //     "http://192.168.50.124:8383"; // for playlists
const BE_ENDPOINT =  "/api"; // "http://127.0.0.1:8383"; //


export class AMService {

    // -H 'Authorization: Bearer [developer token]' -H 'Music-User-Token: [music user token]' "https://api.music.apple.com/v1/me/library/songs"
    getSongs() {
        return fetch(AM_ENDPOINT + '/v1/ch/ratings/albums/{id}').then(res => res.json());
    }

    getBTS(){
        return fetch(BE_ENDPOINT+'/am/bts').then(res => res.json());
    }

    getDevToken(){
        return fetch(BE_ENDPOINT + '/am/devtoken').then(res => res.json());
    }

    logGeneratedAMPlaylist(pllink, pl_nr_tracks, access_token) {
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',})
        let data = {'nr_tracks': pl_nr_tracks, 'href': pllink};
        if(access_token !== null ) {
            headers.append('Authorization', `Bearer ${access_token}`);
            return fetch(BE_ENDPOINT + '/am/add_generated_applemusic_playlist', {
                method: 'post',
                body: JSON.stringify(data),
                headers: headers
            }).then(res => res);
        } else {
            return fetch(BE_ENDPOINT + '/am/add_generated_applemusic_playlist_public', {
                method: 'post',
                body: JSON.stringify(data),
                headers: headers
            }).then(res => res);
        }
    }

    // async getPlaylist(devToken, token){
    //     headers: new Headers({
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json',
    //         'Authorization': `Bearer ${devToken}`,
    //         'Music-User-Token': `${token}`
    //     })
    //     let music = window.MusicKit.getInstance();
    //     await music.authorize()
    // }

    createPlaylist (authorized_music, track_ids, name="BTS Playlist", description="Make your own playlist.laramon.ch"){
        const queryParameters = { l: 'en-us'};
        // body json
        let tracks = track_ids.map((id) => {return({id: id, type:'library-songs'})}); //default: running wild, BWL, wild flower
        let body = {
            attributes: {
                name: name,
                description: description,
                isPublic: true
            },
            relationships: {
                tracks: {data: tracks}
            }
        };

        return authorized_music.api.music("/v1/me/library/playlists", queryParameters, { fetchOptions: { method: 'POST', body: JSON.stringify(body) } });
    }

    // that worked
    createEmptyPlaylist (authorized_music){
        const queryParameters = { l: 'en-us'};
        // body json

        let body = {
            attributes: {
                name: "BTS TEST",
                description: "test playlist",
                isPublic: true
            }
        };

        return(authorized_music.api.music("/v1/me/library/playlists", queryParameters, { fetchOptions: { method: 'POST', body: JSON.stringify(body) } }).then((res) => {
            res;
        }))
    }

    addSongsToPlaylist(authorized_music){
        const playlistid ="p.NJZrr0bIlAXqvNb"
        let tracks = [
            {id:'1772351326', type:'library-songs'},
            {id:'1599172208', type:'library-songs'},
            {id:'1654548658', type:'library-songs'}]
        let body = {
            data:tracks
        }
        return(
            authorized_music.api.music('/v1/me/library/playlists/'+playlistid+'/tracks',{},
                { fetchOptions: { method: 'POST', body: JSON.stringify(body) } }).then((res) => {
                res;
            }))
    }

    getPlaylist(authorized_music){
        //const playlistid ="pl.u-yZyVVe3Fd8qax7K" // global id
        const playlistid = 'p.NJZrr0bIlAXqvNb'
        let apiurl = "/v1/me/library/playlists/"+playlistid // '/v1/me/library/playlists' // bts essentials: "p.dl0kkqAczOWVrZp", globalid "pl.e5a782b2b5424d1bbd6b5b9ac04d09a0"
        return(
            authorized_music.api.music(apiurl).then(
                (res) => {
                    return(res);
                }
            )
        )
    }


    getRootFolder(authorized_music){
        const queryParameters = {
            'filter[identity]':'playlistsroot',
        };
        return(authorized_music.api.music(
            "/v1/me/library/playlist-folders",
            queryParameters).then( res =>{
                if(res.response.ok){
                    retrun(res.data)
                } else {
                    return(res.response)
                }
            }
        ))

        //https://api.music.apple.com/v1/me/library/playlist-folders?filter[identity]=playlistsroot
        //https://api.music.apple.com/   me/library/playlist-folders?filter%5Bidentity%5D=playlistsroot
    }

    // createPlaylist (authorized_music){
    //     let song_ids = ['1772351326', '1599172208', '1654548658'] // running wild, BWL, wild flower
    //     const queryParameters = { tracks: ['1772351326', '1599172208', '1654548658'], l: 'en-us' };
    //     return(authorized_music.api.music("/v1/me/library/playlists", queryParameters, { fetchOptions: { method: 'POST' } }).then((res) => {
    //         res;
    //     }))
    // }

}